import { obterParametrosDaURL } from "../../../../functions";
import { api } from "../../api";
import { ApiException } from "../../api-exception";
import { ILoteDocumento } from "./ObterDocumentosDoLoteAgrupadosPorLoja";

export const ObterDetalhesDeContasAPagarPendente = async (Vencimento: string) => {
  const { token } = obterParametrosDaURL();

  try {
    const { data } = await api.get<Omit<ILoteDocumento, "codLoja">[]>(
      `/obter-detalhes-de-contas-a-pagar-pendentes-pelo-dia`,
      {
        params: {
          Vencimento
        },
        headers: {
          token,
        },
      }
    );

    return data;
  } catch (erro) {
    throw new ApiException(
      erro,
      "Não conseguimos obter detalhes de contas a pagar pendentes do dia informado"
    );
  }
};
